// extracted by mini-css-extract-plugin
export default {"card":"WidgetTemplateCard_card__JunoU","icon":"WidgetTemplateCard_icon__WXVSb","label":"WidgetTemplateCard_label__VZohS","description":"WidgetTemplateCard_description__+b8qX"};